// class ProductBuyButtons extends HTMLElement{constructor(){super()}connectedCallback(){this.button_container=this.querySelector(".product-buy-buttons--primary"),this.button_text=this.querySelector(".product-buy-buttons--cta-text"),this.form=this.querySelector(".product-buy-buttons--form"),this.requested_quantity=1,this.select_input=this.querySelector(".product-buy-buttons--select"),this.smart_button=this.querySelector(".product-buy-buttons--smart"),this.primary_button=this.querySelector(".product-buy-buttons--cta"),this.addToCartListener(),this.updateViewListener(),this.updateQuantityListener()}addToCartListener(){this.form.on("submit",async t=>{var e=this.form.querySelector("option[selected]"),i=theme.utils.getAvailableQuantity(this.dataset.id,e.dataset,this.requested_quantity);if("drawer"!==theme.settings.cart_type&&!1!==i||(t.preventDefault(),t.stopPropagation()),i&&(this.button_container.setAttribute("data-loading",!0),"drawer"===theme.settings.cart_type))try{await theme.cart.addItem(e.dataset.id,i),this.button_container.setAttribute("data-loading",!1),theme.drawer.open("right","cart",this.primary_button)}catch(t){throw this.button_container.setAttribute("data-loading",!1),new Error(t)}})}updateViewListener(){window.on(`theme:product:${this.dataset.id}:variantChanged`,({detail:{variant:t}})=>{var e=this.select_input.querySelector("option[selected]");e&&e.removeAttribute("selected"),t&&t.available?(this.selectVariant(t.id),this.updateView(!0,!0)):t&&!t.available?(this.selectVariant(t.id),this.updateView(!1,!0)):this.updateView(!1,!1)})}selectVariant(t){var e=this.select_input.querySelector(`option[value='${t}']`);e&&e.setAttribute("selected",!0)}updateView(t,e){t?(this.primary_button.removeAttribute("disabled"),this.button_text.innerText=theme.translations.add_to_cart,this.smart_button&&(this.smart_button.style.display="block")):(this.primary_button.setAttribute("disabled",!0),this.smart_button&&(this.smart_button.style.display="none"),this.button_text.innerText=e?theme.translations.out_of_stock:theme.translations.unavailable)}updateQuantityListener(){window.on(`theme:product:${this.dataset.id}:quantityChanged`,({detail:t})=>{this.requested_quantity=t})}}const productBuyButtonsEl=customElements.get("product-buy-buttons-root");productBuyButtonsEl||customElements.define("product-buy-buttons-root",ProductBuyButtons);

/** Shopify CDN: Minification failed

Line 16:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 16:55 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:83 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:618 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:643 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 16:1229 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:1293 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 16:1301 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 16:1577 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:1686 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 3 more hidden warnings

**/

class ProductBuyButtons extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.button_container = this.querySelector(
      ".product-buy-buttons--primary"
    )),
      (this.second_button_container = this.querySelector(
      ".product-buy-buttons--secondary"
    )),
      (this.button_text = this.querySelector(".product-buy-buttons--cta-text")),
      (this.form = this.querySelector(".product-buy-buttons--form")),
      (this.requested_quantity = 1),
      (this.select_input = this.querySelector(".product-buy-buttons--select")),
      (this.smart_button = this.querySelector(".product-buy-buttons--smart")),
      (this.primary_button = this.querySelector(".product-buy-buttons--cta")),
      // (this.tbyb =
      //   this.querySelector("#tbybButton").getAttribute("data-is-tbyb")),
      this.addToCartListener(),
      this.updateViewListener(),
      this.updateQuantityListener();
     this.checkVisibility = this.checkVisibility.bind(this);

    this.checkVisibility();
    window.addEventListener('scroll', this.checkVisibility);
  }
  addToCartListener() {
    let tbyb = false;

    tbybButton = document.getElementById("tbybButton");
    tbybButton.addEventListener(
      "click",
      () => {
        tbyb = true;
      },
      true
    );

    this.form.on("submit", async (t) => {
      t.preventDefault();
      var e = this.form.querySelector("option[selected]"),
        i = theme.utils.getAvailableQuantity(
          this.dataset.id,
          e.dataset,
          this.requested_quantity
        );

      var lineItemProperties = {
        tbybEnabled: e.dataset.id, // 'tbyb' property with variant ID
      };

      if (
        (("drawer" !== theme.settings.cart_type && !1 !== i) ||
          (t.preventDefault(), t.stopPropagation()),
        i &&
          (this.button_container.setAttribute("data-loading", !0),this.second_button_container.setAttribute("data-loading", !0),
          "drawer" === theme.settings.cart_type))
      )
        try {
          if (tbyb == true) {
            await theme.cart.addItem(e.dataset.id, i, lineItemProperties);
            console.log("is tbyb");
          } else {
            await theme.cart.addItem(e.dataset.id, i);
            console.log("not tbyb");
          }

          this.button_container.setAttribute("data-loading", !1),
            this.second_button_container.setAttribute("data-loading", !1),
            theme.drawer.open("right", "cart", this.primary_button);
        } catch (t) {
          throw (
            (this.button_container.setAttribute("data-loading", !1),this.second_button_container.setAttribute("data-loading", !1),
            new Error(t))
          );
        }
      tbyb = false;
    });
  }
  updateViewListener() {
    window.on(
      `theme:product:${this.dataset.id}:variantChanged`,
      ({ detail: { variant: t } }) => {
        var e = this.select_input.querySelector("option[selected]");
        e && e.removeAttribute("selected"),
          t && t.available
            ? (this.selectVariant(t.id), this.updateView(!0, !0))
            : t && !t.available
            ? (this.selectVariant(t.id), this.updateView(!1, !0))
            : this.updateView(!1, !1);
      }
    );
  }
  selectVariant(t) {
    var e = this.select_input.querySelector(`option[value='${t}']`);
    e && e.setAttribute("selected", !0);
  }
  updateView(t, e) {
    t
      ? (this.primary_button.removeAttribute("disabled"),
        (this.button_text.innerText = theme.translations.add_to_cart),
        this.smart_button && (this.smart_button.style.display = "block"))
      : (this.primary_button.setAttribute("disabled", !0),
        this.smart_button && (this.smart_button.style.display = "none"),
        (this.button_text.innerText = e
          ? theme.translations.out_of_stock
          : theme.translations.unavailable));
  }
  updateQuantityListener() {
    window.on(
      `theme:product:${this.dataset.id}:quantityChanged`,
      ({ detail: t }) => {
        this.requested_quantity = t;
      }
    );
  }
  checkVisibility() {
    //const button = this.querySelector(".product-buy-buttons--primary");//document.getElementById('product-buy-buttons--primary');
    if (window.innerWidth <= 768) { // Only run on mobile devices
     
      
     const rect = this.button_container.getBoundingClientRect();
      if ((rect.top >= 55 && rect.top <= window.innerHeight) || 
      (rect.bottom >= 55 && rect.bottom <= window.innerHeight)) {        
        this.second_button_container.classList.remove('sticky');
        
      } else {
        this.second_button_container.classList.add('sticky');
         
      }
    } else {
      this.second_button_container.classList.remove('sticky'); // Ensure button is not sticky on larger screens
       
    }
  }
}
const productBuyButtonsEl = customElements.get("product-buy-buttons-root");
productBuyButtonsEl ||
  customElements.define("product-buy-buttons-root", ProductBuyButtons);
